export const downloadFile = (file, directory) =>
    window.open(`/services/plugin-upload/download/${directory ? `${directory}/` : ''}${file.uuid}`);